/**
 * @generated SignedSource<<72bb3aee0ee100089ed4d27a6d9efbbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventPractitionerSendInvitationInput = {
  eventId: string;
};
export type eventPractitionerSendInvitationMutation$variables = {
  input: EventPractitionerSendInvitationInput;
};
export type eventPractitionerSendInvitationMutation$data = {
  readonly sendEventPractitionerInvitation: {
    readonly success: boolean;
    readonly message: string;
  };
};
export type eventPractitionerSendInvitationMutation = {
  variables: eventPractitionerSendInvitationMutation$variables;
  response: eventPractitionerSendInvitationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EventPractitionerSendInvitationPayload",
    "kind": "LinkedField",
    "name": "sendEventPractitionerInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eventPractitionerSendInvitationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eventPractitionerSendInvitationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f23cfc9f3b28461842c5dfad45e40ec4",
    "id": null,
    "metadata": {},
    "name": "eventPractitionerSendInvitationMutation",
    "operationKind": "mutation",
    "text": "mutation eventPractitionerSendInvitationMutation(\n  $input: EventPractitionerSendInvitationInput!\n) {\n  sendEventPractitionerInvitation(input: $input) {\n    success\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "c7e613d8c669dd86a798a0390cd14887";

export default node;
